import React, { useEffect, useState, useCallback } from "react"
import { ThemeProvider, CssBaseline } from "@material-ui/core"
import { createMuiTheme } from "@material-ui/core/styles"
import AdminStripeDiscountCodeListContainer from "../../containers/AdminContainer/AdminStripeDiscountCodeListContainer"
import services from "../../services"

const darkTheme = createMuiTheme({
  palette: {
    type: "dark",
  },
})

function AdminStripeDiscountCodesPage() {
  const [discountCodes, setDiscountCodes] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  const fetchDiscountCodes = useCallback(async () => {
    try {
      setLoading(true)
      setError(null)

      const response = await services.stripeDiscountCodeAdminServices.getDiscountCodes()

      if (response && response.data && response.data.data) {
        setDiscountCodes(response.data.data.discount_codes || [])
      } else {
        setDiscountCodes([])
      }
    } catch (err) {
      console.error("Error fetching discount codes:", err)
      setError(err.response?.data?.error || err.message || "Failed to load discount codes")
      setDiscountCodes([])
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    fetchDiscountCodes()
  }, [fetchDiscountCodes])

  const handleCreate = async (data) => {
    await services.stripeDiscountCodeAdminServices.createDiscountCode(data)
    await fetchDiscountCodes()
  }

  const handleUpdate = async (id, data) => {
    await services.stripeDiscountCodeAdminServices.updateDiscountCode(id, data)
    await fetchDiscountCodes()
  }

  const handleDelete = async (id) => {
    await services.stripeDiscountCodeAdminServices.deleteDiscountCode(id)
    await fetchDiscountCodes()
  }

  return (
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />
      <AdminStripeDiscountCodeListContainer
        discountCodes={discountCodes}
        loading={loading}
        error={error}
        onCreate={handleCreate}
        onUpdate={handleUpdate}
        onDelete={handleDelete}
      />
    </ThemeProvider>
  )
}

export default AdminStripeDiscountCodesPage
